import ApsResponseDownloadFilter from './SelectionFiltersModel'
function MySavedFilter() {
    return {
        id: null,
        name: null,
        selectionFilters: ApsResponseDownloadFilter()
      }
}
export default MySavedFilter;